import {
  DatabaseOutlined,
  DeploymentUnitOutlined,
  DollarOutlined,
  FunnelPlotOutlined,
  ShoppingOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { CRM } from "@/shared/modules/constants/modules-id";
import { COUNTERPARTIES_PATH } from "@/modules/crm/pages/counterparties";
import { PRODUCTS_PATH } from "@/modules/crm/pages/products";
import { OPPORTUNITIES_PATH } from "@/modules/crm/pages/oportunities";
import { NavigationItem } from "@/modules/common/features/navigation/model/types";
import { AccessTokens } from "gql/graphql";
import { SALES_FUNNEL_PATH } from "@/modules/crm/pages/sales-funnel";
import { CRM_DOCUMENT_REGISTER_PATH } from "@/modules/crm/pages/document-register";

export const crmMenu: NavigationItem[] = [
  {
    label: "crm",
    icon: <DeploymentUnitOutlined />,
    requiredModule: CRM,
    children: [
      {
        label: "counterparties",
        icon: <TeamOutlined />,
        to: COUNTERPARTIES_PATH,
        requiredAtLeastOnePermission: [AccessTokens.CrmCounterparties],
      },
      {
        label: "products",
        icon: <ShoppingOutlined />,
        to: PRODUCTS_PATH,
        requiredAtLeastOnePermission: [AccessTokens.CrmProducts],
      },
      {
        label: "opportunities",
        icon: <DollarOutlined />,
        to: OPPORTUNITIES_PATH,
        requiredAtLeastOnePermission: [AccessTokens.CrmOpportunities],
      },
      {
        label: "sales funnel",
        icon: <FunnelPlotOutlined />,
        to: SALES_FUNNEL_PATH,
        requiredAtLeastOnePermission: [AccessTokens.CrmOpportunities],
      },
      {
        label: "document register",
        icon: <DatabaseOutlined />,
        to: CRM_DOCUMENT_REGISTER_PATH,
        requiredAtLeastOnePermission: [AccessTokens.CrmDocumentsAccess],
      },
    ],
  },
];
